import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import NotFound from './utils/NotFound'
import { CssBaseline, ThemeProvider } from '@mui/material'
import Simulation from './components/simulation/Simulation'
import { theme } from './utils/theme'
import ProtectedRoutes from './utils/ProtectedRoutes'
import Login from './components/login/Login'
import { AuthContextProvider } from './context/AuthContext'
import LoginRoutes from './utils/LoginRoutes'
import Simulations from './components/simulations/Simulations'

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthContextProvider>
          <Routes>
            <Route element={<ProtectedRoutes />}>
              <Route element={<Simulations />} path='/' />
              <Route element={<Simulation />} path='/:name' />
            </Route>
            <Route element={<LoginRoutes />}>
              <Route element={<Login />} path='/login' />
            </Route>
            <Route path='*' element={<NotFound />} />
          </Routes>
        </AuthContextProvider>
      </Router>
    </ThemeProvider>
  )
}
